export const MENU_PANEL = {
  tDuration: 0.5,
  panelLength: 20,
}